import { useState } from 'react';

import { TermsContent, TermsFooter } from './_containers';

export default function TermsAndConditionsPage() {
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { scrollHeight, scrollTop, clientHeight } = e.currentTarget;
    const footerHeight = 164;
    const isBottom = scrollHeight - scrollTop - clientHeight <= footerHeight;
    if (isBottom && !isScrolledToBottom) {
      setIsScrolledToBottom(true);
    }
  };

  return (
    <div className='mx-auto flex h-dvh max-w-md flex-col overflow-hidden'>
      <TermsContent onScroll={handleScroll} />
      <TermsFooter isScrolledToBottom={isScrolledToBottom} />
    </div>
  );
}
